import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Storia from "@/components/site/Storia";
import Sienite from "@/components/site/Sienite";
import Localizzazione from "@/components/site/Localizzazione";
import Contatti from "@/components/site/Contatti";
import Footer from "@/components/site/Footer";
import Marquee from "@/components/site/Marquee";
import ChatBot from "@/components/site/ChatBot";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Header />
      <Hero />
      <Marquee />
      <Storia />
      <Sienite />
      <Localizzazione />
      <Contatti />
      <Footer />
      <ChatBot />
    </main>
  );
}
